import { environment } from 'environments/environment';

export function processAssetUrl(url: string): string {
  return url.startsWith('/Asset/')
    ? environment.baseUrl + url.replace('/Asset/', '/Api/AssetsDownload/')
    : url.replace('/Asset/', '/Api/AssetsDownload/');
}
